'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

(function () {
  'use strict';

  var EventEmitter = require('events').EventEmitter;
  var nextFrame = typeof window === 'undefined' ? setImmediate : window.requestAnimationFrame;
  var cancelFrame = typeof window === 'undefined' ? clearImmediate : window.cancelAnimationFrame;
  var secondPassed = function secondPassed(current, last) {
    return Math.floor(current / 1000) !== Math.floor(last / 1000);
  };

  var Timer = function (_EventEmitter) {
    _inherits(Timer, _EventEmitter);

    function Timer(current) {
      _classCallCheck(this, Timer);

      var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Timer).call(this));

      _this.current = _this._last = _this._pivot = current ? current : 0;
      _this.loop = function () {
        var passed = Date.now() - _this._lastStarted;
        _this.current = _this._pivot + passed;
        _get(Object.getPrototypeOf(Timer.prototype), 'emit', _this).call(_this, 'frame', { milliseconds: _this.current });
        //if(Math.floor(this.current / 1000) !== Math.floor(this._last / 1000)){
        if (secondPassed(_this.current, _this._last)) {
          _get(Object.getPrototypeOf(Timer.prototype), 'emit', _this).call(_this, 'second', { milliseconds: _this.current });
        }
        _this._last = _this.current;
        _this.timeout = nextFrame(_this.loop, 0);
      };
      return _this;
    }

    _createClass(Timer, [{
      key: 'reset',
      value: function reset(offset) {
        this.stop();
        this.current = this._last = this._pivot = offset ? offset : 0;
        _get(Object.getPrototypeOf(Timer.prototype), 'emit', this).call(this, 'reset', { milliseconds: this.current });
      }
    }, {
      key: 'start',
      value: function start() {
        this._lastStarted = Date.now();
        _get(Object.getPrototypeOf(Timer.prototype), 'emit', this).call(this, 'start', { milliseconds: this.current });
        this.timeout = nextFrame(this.loop, 0);
      }
    }, {
      key: 'stop',
      value: function stop() {
        this._pivot = this.current;
        cancelFrame(this.timeout);
        _get(Object.getPrototypeOf(Timer.prototype), 'emit', this).call(this, 'stop', { milliseconds: this.current });
      }
    }]);

    return Timer;
  }(EventEmitter);

  module.exports = Timer;
})();

